// 결제 내역 한 줄의 부계정 추가 금액 — 결제 금액에서 요금제 기본가를 뺀 값 //
// 서버는 구독료와 부계정 요금을 한 건으로 청구해 합계만 남기므로, 기본가보다 비싼 만큼을 부계정 몫으로 본다 //
// 쿠폰·알림 사용료 행과 기본가를 모르는 경우(요약 미수신·구독 없음)는 0 을 돌려준다 //
export function getSubAccountExtraAmount(data, basePrice) {
  if (!basePrice || basePrice <= 0) return 0;

  if (data.division === 'Coupon') return 0;

  if ((data.itemName ?? '').startsWith('(알림)')) return 0;

  const extraAmount = data.price - basePrice;

  return extraAmount > 0 ? extraAmount : 0;
}
